// Recipient & Occasion discovery mapping for the Explore Gifts experience.
// Every card ALWAYS resolves to a delightful set of gifts (never empty):
// if a category has no dedicated catalog data yet, we fall back to curated
// best-sellers and surface a warm "we're curating more" message.

export const RECIPIENTS = [
  { key: "mother", label: "Mother", icon: "flower", collections: ["self-care", "memory-gifts"], occasions: [], keywords: ["mother", "mom", "mum", "maa"] },
  { key: "father", label: "Father", icon: "briefcase", collections: ["memory-gifts"], occasions: [], keywords: ["father", "dad", "papa"] },
  { key: "sister", label: "Sister", icon: "heart", collections: ["for-sister"], occasions: ["For Sister"], keywords: ["sister", "sis"] },
  { key: "brother", label: "Brother", icon: "users", collections: ["best-friend"], occasions: [], keywords: ["brother", "bro", "rakhi"] },
  { key: "girlfriend", label: "Girlfriend", icon: "heart-handshake", collections: ["for-girlfriend"], occasions: ["For Girlfriend"], keywords: ["girlfriend", "love"] },
  { key: "boyfriend", label: "Boyfriend", icon: "heart-handshake", collections: ["for-girlfriend", "for-wife"], occasions: [], keywords: ["boyfriend", "love", "him"] },
  { key: "friends", label: "Friends", icon: "users", collections: ["best-friend"], occasions: ["Best Friend"], keywords: ["friend", "bestie", "buddy"] },
  { key: "kids", label: "Kids", icon: "baby", collections: [], occasions: [], keywords: ["kid", "child", "baby", "little"] },
  { key: "corporate", label: "Corporate", icon: "building", collections: [], occasions: [], keywords: ["corporate", "office", "premium", "team", "colleague"] },
];

export const OCCASIONS = [
  { key: "birthday", label: "Birthday", icon: "cake", collections: ["birthday-gifts"], occasions: ["Birthday"], keywords: ["birthday"] },
  { key: "anniversary", label: "Anniversary", icon: "heart", collections: ["memory-gifts", "for-wife"], occasions: ["For Wife"], keywords: ["anniversary", "couple"] },
  { key: "congratulations", label: "Congratulations", icon: "party-popper", collections: [], occasions: [], keywords: ["congrat", "achievement", "promotion"] },
  { key: "thank-you", label: "Thank You", icon: "sparkles", collections: ["self-care"], occasions: [], keywords: ["thank", "gratitude"] },
  { key: "self-care", label: "Self Care", icon: "flower", collections: ["self-care"], occasions: ["Self Care"], keywords: ["self care", "relax", "spa", "pamper"] },
  { key: "wedding", label: "Wedding", icon: "gem", collections: ["for-wife"], occasions: [], keywords: ["wedding", "bride", "couple", "shaadi"] },
  { key: "festivals", label: "Festivals", icon: "gift", collections: [], occasions: [], keywords: ["festival", "diwali", "rakhi", "christmas", "eid"] },
];

export const BUDGETS = [
  { key: "all", label: "Any budget", max: null },
  { key: "under-599", label: "Under ₹599", max: 599 },
  { key: "under-999", label: "Under ₹999", max: 999 },
];

export const getRecipient = (key) => RECIPIENTS.find((r) => r.key === key) || null;
export const getOccasion = (key) => OCCASIONS.find((o) => o.key === key) || null;

const matchesDef = (p, def) => {
  const pc = p.collections || [];
  if ((def.collections || []).some((c) => pc.includes(c))) return true;
  if ((def.occasions || []).some((o) => (p.occasion || "") === o)) return true;
  const hay = `${p.name || ""} ${p.tagline || ""} ${p.description || ""} ${p.occasion || ""}`.toLowerCase();
  if ((def.keywords || []).some((k) => hay.includes(k))) return true;
  return false;
};

// Returns { list, curated, def } — `curated` true means we fell back to best-sellers.
export function filterParcels(parcels, { recipient, occasion, budget } = {}) {
  let list = Array.isArray(parcels) ? [...parcels] : [];
  const def = recipient ? getRecipient(recipient) : occasion ? getOccasion(occasion) : null;
  let curated = false;

  if (def) {
    const matched = list.filter((p) => matchesDef(p, def));
    if (matched.length > 0) list = matched;
    else curated = true; // keep all → curated best-sellers
  }

  const b = BUDGETS.find((x) => x.key === budget);
  if (b && b.max) {
    const within = list.filter((p) => Number(p.price) <= b.max);
    // don't wipe results to zero on budget alone — only apply if something remains
    if (within.length > 0) list = within;
  }

  return { list, curated, def };
}

export const discoveryTitle = ({ recipient, occasion } = {}) => {
  const r = getRecipient(recipient);
  if (r) return `Gifts for ${r.label}`;
  const o = getOccasion(occasion);
  if (o) return `${o.label} Gifts`;
  return "Explore Gifts";
};

export const CURATED_NOTE = "We're curating more gifts for this category. Meanwhile, here are our handpicked recommendations.";
